import React from "react";
import { RegisterProps } from "../../../types/helpers";

export const RegisterSuccess : React.FC<RegisterProps> = ({increaseStep, decreaseStep}) => {

    return (
        <>
        <div className="card">
            <div className="card-header">Regitro realizado com sucesso</div>
            <div className="card-body">
                <p>Nossa equipe já está realizando o processo de analise, e retorná com o Status em breve.</p>
            </div>
        </div>
        </>
    )
}